export default {
    categories: [
        {
            id: 5,
            name: 'categories',
            isRoot: true,
            children: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
        },

        { id: 0, name: 'animals', isRoot: false, children: [1, 2, 3] },
        { id: 1, name: 'cute', isRoot: false, children: [] },
        { id: 2, name: 'scary', isRoot: false, children: [] },
        { id: 3, name: 'weird', isRoot: false, children: [] },

        { id: 10, name: 'beard', isRoot: false, children: [11, 12] },
        { id: 11, name: 'curly', isRoot: false, children: [] },
        { id: 12, name: 'straight', isRoot: false, children: [] },

        { id: 20, name: 'business', isRoot: false, children: [] },

        { id: 30, name: 'cars', isRoot: false, children: [31, 32] },
        { id: 31, name: 'fast', isRoot: false, children: [] },
        { id: 32, name: 'slow', isRoot: false, children: [] },

        { id: 40, name: 'city', isRoot: false, children: [] },
        { id: 50, name: 'flowers', isRoot: false, children: [] },

        { id: 60, name: 'food', isRoot: false, children: [61, 62] },
        { id: 61, name: 'liquid', isRoot: false, children: [] },
        { id: 62, name: 'solid', isRoot: false, children: [] },

        { id: 70, name: 'nature', isRoot: false, children: [] },

        { id: 80, name: 'people', isRoot: false, children: [81, 82, 83] },
        { id: 81, name: 'one', isRoot: false, children: [] },
        { id: 82, name: 'couple', isRoot: false, children: [] },
        { id: 83, name: 'many', isRoot: false, children: [] },

        { id: 90, name: 'sports', isRoot: false, children: [] },
        { id: 100, name: 'tech', isRoot: false, children: [] },
        { id: 110, name: 'travel', isRoot: false, children: [] },
        { id: 120, name: 'water', isRoot: false, children: [] },
    ],
    stores: [
        {
            id: 0,
            city: 'Hamburg',
            country: 'Deutschland',
            address: 'Moorfuhrtweg 13',
            created_at: new Date(1988, 4, 20),
        },
        {
            id: 1,
            city: 'Hannover',
            country: 'Deutschland',
            address: 'Joachimstraße 1',
            created_at: new Date(1992, 3, 11),
        },
        {
            id: 2,
            city: 'Paris',
            country: 'Frankfreich',
            address: '17 Route de la Reine FR-92100 Boulogne-Billancourt',
            created_at: new Date(1993, 6, 27),
        },
        {
            id: 3,
            city: 'Mailand',
            country: 'Italien',
            address: 'Viale Famagosta, 75 IT-20142 Milano',
            created_at: new Date(1994, 1, 2),
        },
        {
            id: 4,
            city: 'Düsseldorf',
            country: 'Deutschland',
            address: 'Peter-Müller-Straße 10',
            created_at: new Date(2001, 11, 5),
        },
        {
            id: 5,
            city: 'Kiel',
            country: 'Deutschland',
            address: 'Einsteinstraße 5',
            created_at: new Date(2008, 7, 15),
        },
        {
            id: 6,
            city: 'Zürich',
            country: 'Schweiz',
            address: 'Weberstrasse 9',
            created_at: new Date(2008, 7, 15),
        },
        {
            id: 7,
            city: 'Frankfurt am Man',
            country: 'Deutschland',
            address: 'Wilhelm-Leuschner-Straße 79',
            created_at: new Date(2008, 7, 15),
        },
        {
            id: 8,
            city: 'München',
            country: 'Deutschland',
            address: 'Otl-Aicher-Straße 64',
            created_at: new Date(2008, 7, 15),
        },
    ],
    locks: [],
};
